import MuiButton from './MuiButton'
import MuiFormLabel from './MuiFormLabel'
import MuiIconButton from './MuiIconButton'
import MuiInputLabel from './MuiInputLabel'
import MuiOutlinedInput from './MuiOutlinedInput'
import MuiPaper from './MuiPaper'
import MuiTableCell from './MuiTableCell'
import MuiTableHead from './MuiTableHead'
import MuiTypography from './MuiTypography'
import MuiAccordion from './MuiAccordion'
import MuiAccordionDetails from './MuiAccordionDetails'
import MuiAccordionSummary from './MuiAccordionSummary'
import MuiSlider from './MuiSlider'
import MuiAppBar from './MuiAppBar'
import MuiCssBaseline from './MuiCssBaseline'
import MuiList from './MuiList'
import MuiListItem from './MuiListItem'
import MuiListItemText from './MuiListItemText'
import MuiListSubheader from './MuiListSubheader'
import MuiListItemIcon from './MuiListItemIcon'
import MuiChip from './MuiChip'
import MuiTablePagination from './MuiTablePagination'
import MuiIcon from './MuiIcon'
import MuiButtonBase from './MuiButtonBase'
import MuiCheckBox from './MuiCheckbox'
import MuiInputAdornment from './MuiInputAdornment'
import MuiInputBase from './MuiInputBase'

export default {
	MuiButton,
	MuiIconButton,
	MuiPaper,
	MuiTableCell,
	MuiTableHead,
	MuiTypography,
	MuiOutlinedInput,
	MuiFormLabel,
	MuiInputLabel,
	MuiAccordion,
	MuiAccordionDetails,
	MuiAccordionSummary,
	MuiSlider,
	MuiAppBar,
	MuiCssBaseline,
	MuiList,
	MuiListItem,
	MuiListItemText,
	MuiListSubheader,
	MuiListItemIcon,
	MuiChip,
	MuiTablePagination,
	MuiIcon,
	MuiButtonBase,
	MuiCheckBox,
	MuiInputAdornment,
	MuiInputBase,
}
